import paw from '@assets/paw.svg';
import type { CardItemBadge, CardItemStudProps } from '@presentation/components';
import { CardItem } from '@presentation/components';
import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';

export * from './types';

export const CardItemStud: FC<CardItemStudProps> = (props) => {
  const {
    image,
    name,
    location,
    price,
    hasPedigreeBadge,
    hasPedigreeFciBadge,
    breed,
    champion,
    ...rest
  } = props;
  const { translate } = useTranslation();

  return (
    <CardItem
      image={image}
      content={{
        title: name,
        text: location,
        subtitle: price,
      }}
      footer={
        <div>
          {breed} {champion && `- ${champion}`}
        </div>
      }
      badges={[
        ...(!hasPedigreeFciBadge
          ? []
          : [
              {
                label: translate('glossary.pedigreeFci'),
                image: paw,
                color: 'blue',
                expanded: true,
              } as CardItemBadge,
            ]),
        ...(!hasPedigreeBadge || hasPedigreeFciBadge
          ? []
          : [
              {
                label: translate('glossary.pedigree'),
                image: paw,
                color: 'blue',
                expanded: true,
              } as CardItemBadge,
            ]),
      ]}
      {...rest}
    />
  );
};
